<desy-card
  classes="w-1/3"
  [containerClasses]="
    'p-base border-2 mb-4 w-[1200px] lg:min-w-0 custom-card-width border-neutral-light !m-0 !border !border-neutral-500 rounded-[4px]'
  ">
  <div class="text-ms flex flex-col my-2">
    <div class="flex w-[1200px] py-2 px-4 items-end gap-2">
      <h3 class="text-[18px] font-bold flex-1">{{ usageName }}</h3>
      <div
        *ngIf="detailUrl && showReviewButton && ['PENDING', 'EVALUATING'].includes(state.toUpperCase())"
        class="flex gap-4 mr-8">
        <app-buttons
          [classes]="'c-button--sm'"
          [disabled]="isReviewing"
          [label]="'Revisar uso de solución IA'"
          (click)="reviewAiSolutionUsage()" />
      </div>
    </div>

    <div
      *ngIf="stateText || requestingPerson || creationDate"
      class="flex gap-2 w-full min-w-full justify-start items-center pb-2 px-4 mt-4">
      <div
        *ngIf="stateText"
        class="w-3 h-3 color rounded-sm"
        [ngClass]="color"></div>
      <span
        *ngIf="stateText"
        class="font-normal">
        {{ stateText }}
      </span>
      <span class="text-[16px] text-neutral-dark">
        Creado
        <span *ngIf="requestingPerson">por {{ requestingPerson }}</span>
        <span *ngIf="creationDate">el día {{ creationDate | spanishDate }}</span>
      </span>
    </div>

    <div class="border-t md:w-[1150px] border-neutral-300"></div>

    <div
      *ngIf="infoCard.length"
      class="grid grid-cols-1 gap-3 mt-4 px-4 w-full"
      [ngClass]="dataPerRowMdClass">
      <div
        *ngFor="let info of infoCard"
        class="flex flex-col">
        <span class="text-neutral-dark font-regular text-[14px]">{{ info.label }}</span>
        <span
          *ngIf="typeof info.value === 'string'"
          class="font-normal text-black text-[16px]">
          {{ info.value }}
        </span>
        <span
          *ngIf="info.value === null"
          class="font-semibold text-black text-sm">
          No disponible
        </span>
        <desy-tooltip
          *ngIf="isListValue(info.value)"
          id="ai-solution-usage-info">
          <desy-content>
            <span>Total {{ info.value.length }}</span>
          </desy-content>
          <desy-icon type="info"></desy-icon>
          <desy-tooltip-content>
            <ul class="list-none">
              <li *ngFor="let item of info.value">{{ item }}</li>
            </ul>
          </desy-tooltip-content>
        </desy-tooltip>
      </div>
    </div>

    <div
      *ngIf="expectedUse"
      class="mt-4 px-4">
      <desy-details
        classes="pr-6"
        summaryText="Mostrar descripción">
        {{ expectedUse }}
      </desy-details>
    </div>
  </div>
</desy-card>
